// TICKET: https://npco-dev.atlassian.net/browse/TECH-398
// Should move this to a separate nx library
export const UNEXPECTED_ERROR = 'unexpected error'
